'use strict';

module.exports = {
    close: function () {
        const sideModal = $('#sideModal');
        sideModal.on('hide.bs.modal', function () {
            if (sideModal.hasClass('modal-close-refresh')) {
                window.location.reload();
            }
        });
    }
};
